import { NativeMockBackground } from '../../widgets/NativeMockBackground';
import { InstallCard } from './components/InstallCard';

export function PwaInstallYandex() {
  return (
    <NativeMockBackground>
      <InstallCard />
    </NativeMockBackground>
  );
}
